"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDonationHandler = updateDonationHandler;
var _updateDonationFailed = require("@ori-events/update-donation-failed");
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
async function updateDonationHandler({
  detail: {
    choiceId,
    checked
  }
}) {
  const response = await fetch(_types.RequestUrl.UpdateDonation, (0, _utils.getHttpRequestSettings)({
    choiceId,
    checked
  }, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _updateDonationFailed.isUpdateDonationFailedResponse)(data)) {
    const event = new CustomEvent(_updateDonationFailed.Name, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  return data;
}